import {useState} from 'react';
import Icon from '../_icon';
import Dropdown from '../_dropdown';

const DigestArticleSettings = ({reviewItemsPerRival, onSetReviewItemsPerRival}) => {
  const [showInfo, setShowInfo] = useState(false);
  const toggleShowInfo = () => setShowInfo(!showInfo);

  const itemsPerRival = reviewItemsPerRival ?? 1;
  const frequencyOptions =
    [{value: 0, label: 'none'}].concat([...Array(10).keys()].map(n => ({value: n + 1, label: `${n + 1} article${!n ? '' : 's'}`})));

  return (
    <div className="digest-article-settings">
      <div className="digest-setting-header-with-info" data-tracking-id="digest-setting-articles-label">
        <h4 className="u-pt-m"><strong>Number of Articles Included Automatically</strong></h4>
        <Icon icon="info-outline" width={18} height={18} onClick={toggleShowInfo} />
      </div>
      {showInfo && (
        <div className="help-block u-mb-xs">
          Set the maximum number of articles to be automatically included per company in your <strong>Intel Digest</strong>.<br />
          <br />
          Select <strong>None</strong> to disable automatic inclusion of articles.<br />
        </div>
      )}
      <div className="settings-review_frequency-options u-mb-m">
        <div className="ui-dropdown-panel ui-dropdown-panel--left u-pt-xxs u-mb-m" data-testid="company-settings-digest-articles">
          <Dropdown
            label=""
            displayLabel="Select..."
            options={frequencyOptions}
            selectedValue={itemsPerRival}
            keyPrefix="group"
            className="btn secondary"
            containerClass="ui-dropdown--left"
            alignMenuLeft={true}
            onOptionClick={onSetReviewItemsPerRival} />
        </div>
      </div>

    </div>
  );
};

DigestArticleSettings.propTypes = {
  reviewItemsPerRival: PropTypes.number,
  onSetReviewItemsPerRival: PropTypes.func
};

DigestArticleSettings.defaultProps = {
  reviewItemsPerRival: 1,
  onSetReviewItemsPerRival() {}
};

export default DigestArticleSettings;

